import React, { Component } from 'react';
import {List, ListItem, makeSelectable} from 'material-ui/List';
import { inject, observer } from 'mobx-react';
import { Button, ButtonType } from '@checkmarx/cx-ui';
import ActionDone from 'material-ui/svg-icons/action/done';

@inject('translationsStore') @observer
class SelectableListBox extends Component {
    
    componentWillMount() {
      this.props.onOpen();
      this.resetState();
    }
    
    componentWillUnmount()
    {
        this.props.onClose();
    }

    saveSelectedItem = (event) => {
        
        this.props.handleSaveSelectedItem(this.state.selectedIndex);
    }
    
    handleItemChange = (event, index) => {
      
      this.setState({
        selectedIndex: index,
      });
    };

    resetState = () => {
        this.setState({
            selectedIndex: this.props.defaultValue ? this.props.defaultValue : null,
        });
    }

    createItemRow = (item, index) => {
        return (
            <ListItem key={index}
                value={item.value}  
                primaryText={item.text} 
                rightIcon={this.createRightIconForItem(item)}
                className={this.isItemSelected(item) ? 'selected' : '' } 
                innerDivStyle={{paddingTop: '8px', paddingBottom: '8px'}}
                />

        )
    }

    createRightIconForItem = (item) => {
        if(this.isItemSelected(item)){
            return (
                <ActionDone style={{fill: '4a90e2', width: 16, height: 16, right: 14, marginTop: 8 }} />
            )
        }

        return null;
    }

    isItemSelected = (item) => {
        
        return item.value == this.state.selectedIndex;
    }

    createItemRows = () => {
        
        return this.props.selectableItems
            .map((item, index) => 
                this.createItemRow(item, index)
        );
    }

    reset = () => {
      
      this.setState({
        selectedIndex: null,
      });
    };

    render() {
        
        let SelectableList = makeSelectable(List);
        
        return(
            
            <div className='selectable-list-box'>
                <SelectableList value={this.state.selectedIndex} onChange={this.handleItemChange}>
                {   
                    this.createItemRows()
                }
                </SelectableList>
                <div className='selectable-list-box-buttons'>
                    <div className='selectable-list-box-links'>
                    <span className='portal-blank-button link' onClick={this.reset}>
                        { this.props.translationsStore.translate('RESET') }
                    </span>
                    </div>
                    <div className='save-button'>
                        <Button 
                            onClick={this.saveSelectedItem}
                            text={this.props.submitLabel}>
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default SelectableListBox;